import React, { useEffect, useState, useRef } from "react";
import "./css/Navbar.css";
import logo from "../../assets/samyak_Sankalp_logo.png";
import { Link, useNavigate } from 'react-router-dom';
import { openVolunteerPopup } from "../features/volunteerPopupSlice";
import { useDispatch } from "react-redux";
import { useParams } from 'react-router-dom' // Import this

const OUR_WORK_LINKS = [
  { label: "Faith Aalingan Sansthan" },
  { label: "Humanity Welfare" },
  { label: "Retinoblastoma Treatment" },
];

const createSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, "")
    .replace(/\s+/g, "-");
};

const EVENTS_LINKS = [
  { label: "festivities" },
  { label: "Enrichment Programs" },
  { label: "Excursions" },
  { label: "Expressions" },
];

export default function Navbar() {
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null); // 'ourwork' | 'events' | null
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1280);
  const navigate = useNavigate();
  const navRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1280);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    const scriptId = "google-translate-script";
    window.googleTranslateElementInit = () => {
      const elementId = isMobile ? "google_translate_mobile" : "google_translate_desktop";
      if (window.google?.translate) {
        new window.google.translate.TranslateElement(
          { pageLanguage: "en", includedLanguages: "en,hi" },
          elementId
        );
      }
    };
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    } else {
      window.googleTranslateElementInit();
    }
  }, [isMobile]);

  const handleContactClick = () => {
    setMenuOpen(false);
    setOpenDropdown(null);
    navigate("/connect");
  };

  const handleVolunteerClick = () => {
    dispatch(openVolunteerPopup());
    setMenuOpen(false);
  };

  const closeAll = () => {
    setMenuOpen(false);
    setOpenDropdown(null);
  };

  const toggleDropdown = (name) => {
    setOpenDropdown((prev) => (prev === name ? null : name));
  };

  return (
    <>
      <div className={`menu-overlay${menuOpen ? " active" : ""}`} onClick={closeAll} />

      <header className="navbar" ref={navRef}>
        <div className="customcontainer navbar-inner">

          <Link className="nav-logo" to="/" onClick={closeAll}>
            <img src={logo} alt="Samyak Sankalp" />
          </Link>

          <nav className={`nav-links${menuOpen ? " open" : ""}`}>

            <Link to="/" onClick={closeAll}>Home</Link>
            <Link to="/about-us" onClick={closeAll}>About Us</Link>

            {/* ---- OUR WORK DROPDOWN ---- */}
            <div className="dd-wrapper">
              <button
                className="dd-trigger"
                onClick={() => toggleDropdown("ourwork")}
                type="button"
              >
                Initiatives
                <svg
                  className={`dd-arrow${openDropdown === "ourwork" ? " rotated" : ""}`}
                  width="12" height="12" viewBox="0 0 12 12" fill="none"
                >
                  <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className={`dd-menu${openDropdown === "ourwork" ? " open" : ""}${isMobile ? " mobile" : ""}`}>
                {OUR_WORK_LINKS.map((item) => (
                  <Link key={item.to} to={`/initiative/${createSlug(item.label)}`} className="dd-item" onClick={closeAll}>
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>

            {/* ---- EVENTS DROPDOWN ---- */}
            <div className="dd-wrapper">
              <button
                className="dd-trigger"
                onClick={() => toggleDropdown("events")}
                type="button"
              >
                Engagements
                <svg
                  className={`dd-arrow${openDropdown === "events" ? " rotated" : ""}`}
                  width="12" height="12" viewBox="0 0 12 12" fill="none"
                >
                  <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className={`dd-menu${openDropdown === "events" ? " open" : ""}${isMobile ? " mobile" : ""}`}>
                {EVENTS_LINKS.map((item) => (
                  <Link key={item.to} to={`/engagement/${createSlug(item.label)}`} className="dd-item" onClick={closeAll}>
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>

            <Link to="/contribute" onClick={closeAll}>Contribute</Link>
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                handleVolunteerClick();
              }}
            >
              Volunteer
            </Link>

            {/* Mobile bottom actions */}
            <div className="mobile-actions">
              <button className="contact-btn mobile" onClick={handleContactClick}>
                Connect
              </button>
              <div className="lang-select mobile">
                <div id="google_translate_mobile"></div>
              </div>
            </div>

          </nav>

          <div className="nav-actions">
            <button className="contact-btn desktop" onClick={handleContactClick}>
              Connect
            </button>
            <div className="lang-select desktop">
              <div id="google_translate_desktop"></div>
            </div>
            <div
              className={`hamburger${menuOpen ? " active" : ""}`}
              onClick={() => setMenuOpen((v) => !v)}
              role="button"
              aria-label="Toggle menu"
            >
              <span style={{ backgroundColor: menuOpen ? "#fff" : "var(--Background-light-Color)" }}></span>
              <span style={{ backgroundColor: menuOpen ? "#fff" : "var(--Background-light-Color)" }}></span>
              <span style={{ backgroundColor: menuOpen ? "#fff" : "var(--Background-light-Color)" }}></span>
            </div>
          </div>

        </div>
      </header>
    </>
  );
}